
import { useState, useEffect } from "react";
import { platformScreenshots, PlatformScreenshot } from "@/data/platformScreenshots";

const PlatformScreenshotsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-advance carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % platformScreenshots.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const currentScreenshot = platformScreenshots[currentIndex];

  return (
    <div className="relative w-full max-w-2xl mx-auto">
      {/* Main Screenshot Display */}
      <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-white">
        <div className="relative w-full bg-gray-50 overflow-hidden">
          <img 
            src={currentScreenshot.imageUrl} 
            alt={currentScreenshot.title} 
            className="w-full h-auto transition-opacity duration-500"
            loading="lazy"
          />
        </div>
        
        {/* Overlay with screenshot info */}
        <div className="absolute bottom-0 left-0 right-0 bg-black/70 p-6">
          <div className="flex items-center gap-3 mb-2">
            
          </div>
          
          <p className="text-white/90 text-sm">
            {currentScreenshot.description}
          </p>
        </div>
      </div>

      {/* Thumbnail navigation */}
      <div className="flex justify-center gap-2 mt-6">
        {platformScreenshots.map((screenshot, index) => (
          <button 
            key={screenshot.id} 
            onClick={() => goToSlide(index)} 
            className={`w-16 h-12 rounded-lg overflow-hidden border-2 transition-all duration-200 ${
              index === currentIndex ? 'border-saas-blue ring-2 ring-saas-blue/20' : 'border-gray-200 hover:border-gray-300'
            }`} 
            aria-label={`View ${screenshot.title}`}
          >
            <img 
              src={screenshot.imageUrl} 
              alt={screenshot.title} 
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default PlatformScreenshotsCarousel;
